<template>
  <div class="product-page-v2">
    <!-- 顶部banner - 新版设计 -->
    <div class="hero-banner" data-aos="zoom-in">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1>善信智慧医养硬件设施</h1>
        <p class="subtitle">
          推动传统养老模式向智慧化转型，构建智能化养老服务体系
        </p>
        <div class="banner-buttons">
          <el-button type="primary" round class="cta-button" @click="_goContact"
            >立即咨询</el-button
          >
          <!-- <el-button round class="secondary-button">了解更多</el-button> -->
        </div>
      </div>
    </div>

    <!-- 解决方案 - 卡片式布局 -->
    <div class="solutions-section">
      <div class="section-header" data-aos="fade-up">
        <h2>善信智能A8手表主要功能</h2>
        <p class="section-subtitle">全方位守护健康</p>
      </div>

      <div class="solution-grid">
        <div
          v-for="(item, index) in solutions"
          :key="index"
          class="solution-card"
          :data-aos="'fade-up'"
          :data-aos-delay="index * 100"
        >
          <div class="card-image">
            <!-- 图片位置，您可自行替换 -->
            <img :src="item.imgPlaceholder" alt="" />
          </div>
          <div class="card-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
            <!-- <el-button type="text" class="learn-more">
              查看详情 <i class="el-icon-arrow-right"></i>
            </el-button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="section-header" data-aos="fade-up">
      <h2>正在研发ing</h2>
      <p class="section-subtitle">新品即将上市,敬请期待~</p>
    </div>
    <img
      style="width: 100vw; margin-top: -200px"
      src="https://upload.shanxinyy.com/homepage/elseProdoct.jpg"
      alt=""
    />
    <!-- 公司优势 - 时间轴式布局 -->
    <div class="advantages-section">
      <div class="section-header" data-aos="fade-up">
        <h2>专业自研团队，深耕智慧养老领域</h2>
        <p class="section-subtitle">善信医养辐射范围广，提供一站式服务</p>
      </div>

      <div class="timeline-container">
        <div
          v-for="(item, index) in advantages"
          :key="index"
          class="timeline-item"
          :class="{ 'timeline-item-reverse': index % 2 === 0 }"
          :data-aos="index % 2 === 0 ? 'fade-left' : 'fade-right'"
          :data-aos-delay="index * 100"
        >
          <div class="timeline-dot"></div>
          <div class="timeline-content">
            <div class="advantage-icon">
              <i :class="item.icon"></i>
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部CTA - 新版设计 -->
    <div class="cta-section" data-aos="fade">
      <div class="cta-container">
        <h2>开启智慧养老新时代</h2>
        <p>立即体验善信医养专业解决方案</p>
        <el-button type="primary" round class="cta-button" @click="_goContact"
          >免费获取方案</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "aos/dist/aos.css";
import AOS from "aos";

export default {
  name: "ProductPageV2",
  data() {
    return {
      solutions: [
        {
          title: "SOS一键呼救",
          description: `善信智能A8手表配备智能SOS系统，突发情况时，长按3秒即可自动：
            1、秒级报警：即时推送定位至监护平台
            2、三方通话：同步接通家属+急救中心
            3、生命护航：自动发送健康数据至救援人员
            7×24小时响应；厘米级精准定位；跌倒自动检测
            为安全加一道"智能保险"！
            `,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/sos.jpg",
        },
        {
          title: "跌倒报警",
          description: `24小时跌倒监测
搭载高精度六轴传感器，智能识别跌倒动作，准确率高达98.6%
三重应急响应：
1.自动触发警报：即时推送跌倒定位至监护平台
2.智能语音确认：10秒无应答自动升级为紧急事件
3.多方联动救援：同步通知家属+社区服务人员
`,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/ddbj.jpg",
        },
        {
          title: "心率监测",
          description: `医疗级精准监测：搭载PPG光电传感器+AI心率算法，实现24小时不间断监测，误差率＜2bpm，达到临床级检测标准
智能健康管理：1.实时预警：自动识别异常心律（心动过速/过缓）2.趋势分析：生成日/周/月心率曲线图3.专业报告：支持导出PDF格式供医生参考
双重守护系统：1.即时提醒：心率异常时震动+语音双重提醒2.分级预警：自动触发平台报警,如发生意外,客服联系就近医护人员并通知家属子女
`,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/xl2.jpg",
        },
        {
          title: "心脏健康监测",
          description: `采用第四代多通道PPG传感器+ECG心电模块双模监测，通过国家二类医疗器械认证，可检测窦性心律、房颤等11种心律失常，检测准确率达98.2%
全方位心脏评估：1.实时监测：24小时动态心率/血氧/血压联动分析2.智能预警：AI自动识别早搏、房颤等异常心电信号3.专业报告：生成符合医院标准的HRV心率变异性报告
`,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/xzjk.jpg",
        },
        {
          title: "血压监测",
          description: `手表采用光电式血压测量原理，基于腕式血压计数据校准通过PPG技术计算血压趋势值。APP数据收集整理。血压趋势变化一目了然。
智能血压管理：1.全天候监测：每小时自动记录血压趋势2.晨峰预警：智能识别清晨高血压风险时段3.专业报告：生成动态血压曲线图（支持24小时ABPM模式）`,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/xy.jpg",
        },
        {
          title: "睡眠智能监测",
          description: `全程监测睡眠质量，记录完整睡眠结构，准确识别浅睡、深睡REM（快速眼动期）、清醒等状态，对睡眠状况跟踪并分析，帮助提高睡眠质量。
四大核心监测指标：1.睡眠质量评分（基于睡眠总时长、深睡时长等5项参数）2.深睡占比分析（对比同龄人健康基准值）3.心率变异性（评估自主神经系统状态）4.呼吸频率监测（预警睡眠呼吸暂停）
`,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/sm.jpg",
        },
      ],
      advantages: [
        {
          icon: "el-icon-medal",
          title: "10年行业深耕",
          description: "自2015年成立以来，专注智慧养老领域研发与创新",
        },
        {
          icon: "el-icon-cpu",
          title: "自主研发系统",
          description: "拥有2项专利技术,5项软件著作权，系统安全稳定可靠",
        },
        {
          icon: "el-icon-user-solid",
          title: "专业服务团队",
          description: "200+技术专家与养老顾问，提供本地化服务支持",
        },
        {
          icon: "el-icon-office-building",
          title: "一站式养老服务",
          description: "整合当地养老产业上下游，为老人提供一站式服务。",
        },
      ],
    };
  },
  mounted() {
    // 初始化动画库 - 配置更柔和的动画
    AOS.init({
      duration: 1000,
      easing: "ease-out-back",
      once: true,
      offset: 120,
    });

    // 设置Element主题色
    document.documentElement.style.setProperty("--el-color-primary", "#f97d01");
    document.documentElement.style.setProperty(
      "--el-color-primary-light-3",
      "#ff9d3f"
    );
  },
};
</script>

<style lang="scss">
/* 全局主题色 */
$primary-color: #f97d01;
$primary-light: lighten($primary-color, 35%);
$primary-dark: darken($primary-color, 10%);

.product-page-v2 {
  font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #333;
  line-height: 1.6;

  /* 新版Banner设计 */
  .hero-banner {
    height: 600px;
    background: url("https://via.placeholder.com/1920x800?text=善信医养智慧养老")
      center/cover no-repeat;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    overflow: hidden;

    .banner-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba($primary-dark, 0.7),
        rgba($primary-color, 0.5)
      );
    }

    .banner-content {
      position: relative;
      z-index: 2;
      max-width: 900px;
      padding: 0 20px;
      color: #fff;

      h1 {
        font-size: 48px;
        font-weight: 600;
        margin-bottom: 20px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        animation: textGlow 2s infinite alternate;
      }

      .subtitle {
        font-size: 22px;
        margin-bottom: 40px;
        opacity: 0.9;
      }
    }

    .banner-buttons {
      display: flex;
      justify-content: center;
      gap: 20px;

      .cta-button {
        padding: 14px 40px;
        font-size: 18px;
        background-color: $primary-color;
        border: none;
        transition: all 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55);

        &:hover {
          background-color: $primary-dark;
          transform: translateY(-3px) scale(1.05);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        }
      }

      .secondary-button {
        padding: 14px 40px;
        font-size: 18px;
        background-color: transparent;
        border: 2px solid #fff;
        color: #fff;
        transition: all 0.3s;

        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
          transform: translateY(-3px);
        }
      }
    }
  }

  /* 通用区块标题样式 */
  .section-header {
    text-align: center;
    margin: 80px 0 60px;

    h2 {
      font-size: 36px;
      font-weight: 600;
      margin-bottom: 15px;
      color: #333;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 3px;
        background: $primary-color;
        border-radius: 3px;
      }
    }

    .section-subtitle {
      font-size: 18px;
      color: #666;
      margin-top: 20px;
    }
  }

  /* 解决方案网格布局 */
  .solution-grid {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 30px;
  }

  .solution-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: all 0.4s;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);

      .card-image img {
        transform: scale(1.05);
      }

      .learn-more i {
        transform: translateX(5px);
      }
    }

    .card-image {
      height: 400px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s;
      }
    }

    .card-content {
      padding: 25px;

      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #333;
      }

      p {
        font-size: 15px;
        color: #666;
        margin-bottom: 20px;
        line-height: 1.6;
      }
    }

    .learn-more {
      color: $primary-color;
      padding: 0;
      font-weight: 500;

      i {
        margin-left: 5px;
        transition: transform 0.3s;
      }
    }
  }

  /* 时间轴式优势展示 */
  .timeline-container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 2px;
      height: 100%;
      background: linear-gradient(to bottom, $primary-color, $primary-light);
    }
  }

  .timeline-item {
    display: flex;
    justify-content: flex-end;
    padding: 30px 0;
    position: relative;

    &-reverse {
      justify-content: flex-start;
    }

    .timeline-dot {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: $primary-color;
      border: 4px solid #fff;
      box-shadow: 0 0 0 4px $primary-light;
      z-index: 1;
    }

    .timeline-content {
      width: calc(50% - 60px);
      padding: 30px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
      transition: all 0.3s;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      }
    }

    .advantage-icon {
      width: 60px;
      height: 60px;
      margin-bottom: 20px;
      background: $primary-light;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 28px;
        color: $primary-color;
      }
    }

    h3 {
      font-size: 20px;
      margin-bottom: 15px;
      color: #333;
    }

    p {
      font-size: 15px;
      color: #666;
      line-height: 1.6;
    }
  }

  /* 底部CTA区域 */
  .cta-section {
    padding: 100px 0;
    margin-top: 80px;
    background: linear-gradient(135deg, $primary-color, $primary-dark);
    color: #fff;
    text-align: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: -50px;
      left: 0;
      width: 100%;
      height: 100px;
      background: #fff;
      transform: skewY(-3deg);
      transform-origin: top left;
    }

    .cta-container {
      position: relative;
      z-index: 2;
      max-width: 800px;
      margin: 0 auto;
      padding: 0 20px;

      h2 {
        font-size: 36px;
        margin-bottom: 20px;
      }

      p {
        font-size: 18px;
        margin-bottom: 30px;
        opacity: 0.9;
      }
    }

    .cta-button {
      padding: 14px 40px;
      font-size: 18px;
      background: #fff;
      color: $primary-color;
      border: none;
      font-weight: 500;
      transition: all 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55);

      &:hover {
        transform: translateY(-3px) scale(1.05);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
      }
    }
  }

  /* 动画效果 */
  @keyframes textGlow {
    from {
      text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
    }
    to {
      text-shadow: 0 0 20px rgba(255, 255, 255, 0.6),
        0 0 30px rgba(255, 255, 255, 0.4);
    }
  }

  /* 响应式调整 */
  @media (max-width: 992px) {
    .hero-banner {
      height: 500px;

      h1 {
        font-size: 36px !important;
      }

      .subtitle {
        font-size: 18px !important;
      }
    }

    .timeline-container {
      &::before {
        left: 30px;
      }
    }

    .timeline-item {
      justify-content: flex-start !important;
      padding-left: 60px;

      .timeline-dot {
        left: 30px;
      }

      .timeline-content {
        width: 100%;
      }
    }
  }

  @media (max-width: 768px) {
    .hero-banner {
      height: 400px;

      h1 {
        font-size: 28px !important;
      }

      .subtitle {
        font-size: 16px !important;
      }

      .banner-buttons {
        flex-direction: column;
        gap: 15px;

        .cta-button,
        .secondary-button {
          width: 100%;
          max-width: 250px;
          margin: 0 auto;
        }
      }
    }

    .solution-grid {
      grid-template-columns: 1fr;
    }

    .section-header h2 {
      font-size: 28px !important;
    }
  }
}
</style>
